import { render, staticRenderFns } from "./HistoryMonthDetail.vue?vue&type=template&id=f287f2c8"
import script from "./HistoryMonthDetail.vue?vue&type=script&lang=js"
export * from "./HistoryMonthDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pforret/Code/Movix/laravel/showtimes.movix/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f287f2c8')) {
      api.createRecord('f287f2c8', component.options)
    } else {
      api.reload('f287f2c8', component.options)
    }
    module.hot.accept("./HistoryMonthDetail.vue?vue&type=template&id=f287f2c8", function () {
      api.rerender('f287f2c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/HistoryMonthDetail.vue"
export default component.exports